<div>
  <div class="db-ecommerce-emails" [ngClass]="{'blured': website?.isAiBuilderDemo}">
    <ds-tabs class="db-ecommerce-emails__tabs" [activeTabId]="activeTab" (onActiveTabChange)="setTabChange($event)" >
      <ds-tab-head [tabId]="'list'" [activeTabId]="activeTab">
        <span>{{ 'text_emailList' | dbText }}</span>
      </ds-tab-head>
      <ds-tab-head [tabId]="'settings'" [activeTabId]="activeTab">
        <span>{{ 'text_emailSettings' | dbText }}</span>
      </ds-tab-head>
      <ds-tab-content>
        <div class="db-ecommerce-emails__content">
          <ng-container *ngIf="activeTab === 'list'">
            <db-ecommerce-emails-list-table [website]="website"></db-ecommerce-emails-list-table>
          </ng-container>
          <ng-container *ngIf="activeTab === 'settings'">
            <db-ecommerce-emails-settings [website]="website"></db-ecommerce-emails-settings>
          </ng-container>
        </div>
      </ds-tab-content>
    </ds-tabs>
  </div>
</div>
